export const loginModal = {
  loginEmail: "Digite seu e-mail!",
  loginUserName: "Digite seu nome de usuário!",
  loginPassword: "Digite sua senha!",
  loginForgotPassword: "Esqueceu sua senha?",
  loginPasswordRecoverTitle: "Recuperar senha",
  loginPasswordRecover: "Senha recuperada com sucesso",
  loginPasswordRecoverMsg: "Confira seu e-mail para redefinir sua senha",
  loginNoAccount: "Ainda não tem conta?",
  loginRegister: "Cadastre-se",
  loginUserNotFound: "Usuário não encontrado",
  loginIncorrectPasswordEmail: "Usuário ou senha inválidos",
  loginSendBtn: "Entrar",
  loginSessionTitle: "Entrar",
  loginEmailPlaceholder: "E-mail",
  loginEmailLocalPartPlaceholder: "usuario",
  loginEmailDomainOther: "Outro",
  loginEmailCustomDomainPlaceholder: "dominio.com",
  loginPasswordPlaceholder: "Senha",
  loginRecoverEmail:
    "Não lembra o e-mail com que se cadastrou? Recupere sua conta falando com nosso time de suporte.",
  loginSupport: "suporte técnico.",
  loginRememberEmail: "Lembrar meu e-mail",
  loginWithGoogle: "Continuar com o Google",
  loginOrDivider: "ou",
  googleLoginError: "Não foi possível entrar com o Google. Tente de novo.",
  googleNewUserRegister: "Sua conta do Google é nova. Cadastre-se primeiro para continuar.",
};
